module.exports = __webpack_public_path__ + "img/logo.99d24149.png";